import React, { createContext, useContext, useCallback, useMemo, useState } from 'react';

const STORAGE_KEY = 'contify_sales_point_of_sale';

const SalesPointOfSaleContext = createContext(null);

function readStoredPos() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.id && parsed?.name) return parsed;
  } catch {
    /* ignore */
  }
  return null;
}

export function SalesPointOfSaleProvider({ children }) {
  const [selectedPointOfSale, setSelectedPointOfSaleState] = useState(() => readStoredPos());

  const setSelectedPointOfSale = useCallback((pos) => {
    if (!pos?.id) {
      sessionStorage.removeItem(STORAGE_KEY);
      setSelectedPointOfSaleState(null);
      return;
    }
    const payload = {
      id: pos.id,
      code: pos.code || '',
      name: pos.name || '',
      default_warehouse_id: pos.default_warehouse_id || null,
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    setSelectedPointOfSaleState(payload);
  }, []);

  const clearSelectedPointOfSale = useCallback(() => {
    sessionStorage.removeItem(STORAGE_KEY);
    setSelectedPointOfSaleState(null);
  }, []);

  const value = useMemo(
    () => ({
      selectedPointOfSale,
      setSelectedPointOfSale,
      clearSelectedPointOfSale,
    }),
    [selectedPointOfSale, setSelectedPointOfSale, clearSelectedPointOfSale]
  );

  return (
    <SalesPointOfSaleContext.Provider value={value}>{children}</SalesPointOfSaleContext.Provider>
  );
}

export function useSalesPointOfSale() {
  const ctx = useContext(SalesPointOfSaleContext);
  if (!ctx) {
    throw new Error('useSalesPointOfSale debe usarse dentro de SalesPointOfSaleProvider');
  }
  return ctx;
}

export default SalesPointOfSaleContext;
